import WarningIcon from 'assets/icons/alert-animation.gif';
import ButtonCommon from 'components/common/ButtonCommon';
import { EDIT_RECEIVER_FULLNAME_NAME } from 'constants';
import useLang from 'hooks/useLang';
import useStore from 'hooks/useStore';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

import { getFullNameReceiver } from 'components/FormEditReceiver/func';
import {
  DESKTOP_MIN_WIDTH,
  NAME_NO_MATCH_STATUS,
  NAME_PARTIAL_MATCH_STATUS,
} from 'constants';
import useReceiver from 'hooks/receiver/useReceiver';
import { useEffect, useState } from 'react';
import { stringUtils } from 'utils';

const BankNumberAccountPopup = ({
  isOpen,
  holderName,
  currentBankValidateAccNumber,
  onAccept,
  onEdit,
}) => {
  const { t } = useLang();
  const { state } = useStore();
  const { currentReceiver, editReceiverInformation } = state;
  const [receiverFullName, setReceiverFullName] = useState('');

  const { isReceiverOfBusinessType, isReceiverOfIndividualType } =
    useReceiver();

  const { nameMatchStatus, serviceStatus, valid } =
    currentBankValidateAccNumber || {};

  useEffect(() => {
    if (currentReceiver) {
      setReceiverFullName(
        getFullNameReceiver({
          isReceiverOfBusinessType,
          isReceiverOfIndividualType,
          lastName: currentReceiver.lastName,
          firstName: currentReceiver.firstName,
          countryCode: currentReceiver.country.code,
        })
      );
    }
  }, [currentReceiver]);

  const renderBodyContent = () => {
    if (serviceStatus === 'inactive')
      return (
        <SubText
          className="edit"
          dangerouslySetInnerHTML={{
            __html: t('popup_add_bank_confirm_account_correct_2'),
          }}
        />
      );
    if (serviceStatus === 'active' && !valid)
      return (
        <SubText
          className="edit"
          dangerouslySetInnerHTML={{
            __html: t('popup_add_bank_confirm_account_correct_3'),
          }}
        />
      );
    if (holderName) {
      const fullName = currentReceiver
        ? receiverFullName
        : editReceiverInformation?.personalDetails[EDIT_RECEIVER_FULLNAME_NAME];
      if (nameMatchStatus === NAME_NO_MATCH_STATUS)
        return (
          <SubTextInRow
            style={{ textAlign: 'center' }}
            dangerouslySetInnerHTML={{
              __html: t('popup_add_bank_account_correct_no_match', {
                holderName,
                fullName,
              }),
            }}
          />
        );
      if (nameMatchStatus === NAME_PARTIAL_MATCH_STATUS)
        return (
          <SubTextInRow
            style={{ textAlign: 'center' }}
            dangerouslySetInnerHTML={{
              __html: t('popup_add_bank_account_correct_partial_match', {
                holderName,
                fullName,
              }),
            }}
          />
        );
      return (
        <>
          <SubText style={{ marginBottom: '24px', textAlign: 'center' }}>
            {t('popup_add_bank_account_correct_1')}
            <br />
            <b className="holder-from">{holderName}</b>
          </SubText>
          <SubText>
            <p
              dangerouslySetInnerHTML={{
                __html: stringUtils.replaceKeyword(
                  t('popup_add_bank_account_correct_2'),
                  [
                    {
                      key: 'fullName',
                      value: fullName,
                    },
                  ]
                ),
              }}
            />
          </SubText>
        </>
      );
    }
    return (
      <SubText
        className="edit"
        dangerouslySetInnerHTML={{
          __html: t('popup_add_bank_confirm_account_correct'),
        }}
      />
    );
  };

  const renderActionsButton = () => {
    if (
      serviceStatus === 'active' &&
      holderName &&
      nameMatchStatus === NAME_NO_MATCH_STATUS
    )
      return (
        <>
          <ButtonCommon
            value={t('button_edit')}
            onClick={onEdit}
            styles={{
              margin: '0px',
              width: '100%',
            }}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
          />
        </>
      );
    return (
      <>
        <ButtonCommon
          value={t('button_it_correct')}
          onClick={onAccept}
          styles={{
            margin: '0px',
            width: '50%',
          }}
          color="var(--ds-c-blue)"
          background="var(--ds-c-white)"
        />
        <ButtonCommon
          value={t('button_edit')}
          onClick={onEdit}
          styles={{
            margin: '0px',
            width: '50%',
          }}
          color="var(--c-primary)"
          background="var(--bg-primary)"
          isFill={true}
        />
      </>
    );
  };

  return (
    <>
      <style>
        {`
          .bank-number-account-modal-backdrop {
            z-index: 1055!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }

          .modal {
            padding-right: 0px!important;
          }
        `}
      </style>

      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="bank-number-account-modal-backdrop"
        centered
      >
        <ModalBody>
          <img src={WarningIcon} alt="alert-animation.gif" />
          {renderBodyContent()}
        </ModalBody>
        <ModalFooter>{renderActionsButton()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  z-index: 1100;
  & .modal-dialog {
    transform: none;
  }
  & .modal-content {
    padding: 24px;
    border-radius: 12px;
    box-shadow: var(--ds-bs-4);
    background: var(--ds-c-white);
    width: 328px;
    height: fit-content;
    margin-inline: auto;
    border: none;
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  margin-bottom: 32px;

  & img {
    display: block;
    margin-inline: auto;
    margin-bottom: 16px;
    width: 50px;
    height: 50px;
  }
`;
const SubText = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  color: var(--ds-c-grey-dark);
  margin: 0;

  & b {
    margin-inline: auto;
    display: table;
    text-transform: uppercase;

    &.holder-from {
      color: var(--ds-c-red);
    }

    &.holder-to {
      display: initial;
      color: var(--ds-c-blue);
    }
  }

  &.edit {
    b {
      margin-inline: unset;
      display: unset;
      text-transform: unset;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const SubTextInRow = styled(SubText)`
  & b {
    display: unset;
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

export default BankNumberAccountPopup;
